import { render, staticRenderFns } from "./tableRegisteredStudents.vue?vue&type=template&id=5727a50b&"
import script from "./tableRegisteredStudents.js?vue&type=script&lang=js&"
export * from "./tableRegisteredStudents.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports